import React from 'react'
import { Button } from '@material-ui/core'
import { V4_T } from './propertyDetailHelpers'

// Inline warning shown when one or more selected properties already belong to
// another active billing group. Lists exactly what will change, then lets the
// user confirm a "move" (force re-submit). Works inside any host modal — no
// dependency on a host-specific confirm dialog.
//
// conflicts: [{ groupId, name, propertyIds: [number] }]
function BillingGroupConflictNotice ({ conflicts, onConfirm, onCancel, saving }) {
  if (!conflicts || !conflicts.length) return null

  return (
    <div
      style={{
        border: `1px solid ${V4_T.amber || '#b7791f'}`,
        background: '#fffaf0',
        borderRadius: 8,
        padding: '10px 12px',
        marginTop: 6
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <span style={{ fontSize: 16 }}>⚠️</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#7b5800' }}>
          Already in another billing group
        </span>
      </div>
      <div style={{ fontSize: 12, color: V4_T.ink2, marginBottom: 8 }}>
        These properties belong to another active group. Saving will move them
        here and remove them from their current group
        {conflicts.some(c => (c.propertyIds || []).length) ? '' : ''}:
      </div>
      <ul style={{ margin: '0 0 10px', paddingLeft: 18 }}>
        {conflicts.map(conflict => (
          <li key={String(conflict.groupId)} style={{ fontSize: 12, color: V4_T.ink, marginBottom: 2 }}>
            <strong>{conflict.name}</strong>
            {Array.isArray(conflict.propertyIds) && conflict.propertyIds.length
              ? <span style={{ color: V4_T.ink2 }}> — property {conflict.propertyIds.join(', ')}</span>
              : null}
          </li>
        ))}
      </ul>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button size="small" onClick={onCancel} disabled={saving} style={{ color: V4_T.ink2 }}>
          Keep as is
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={onConfirm}
          disabled={saving}
          style={{ fontWeight: 600, background: '#b7791f', color: '#fff' }}
        >
          {saving ? 'Moving…' : 'Move & Save'}
        </Button>
      </div>
    </div>
  )
}

export default BillingGroupConflictNotice
